import React from 'react'

import { useFeatureFlags } from './useFeatureFlags'

/**
 * HOC replacement for LaunchDarkly's `withLDConsumer()`. Subscribes to PostHog
 * feature flags and injects them as a `flags` prop with the same
 * `{ [flagKey]: value }` shape consumers already expect.
 */
const withFeatureFlags = WrappedComponent => {
  const WithFeatureFlags = props => {
    const flags = useFeatureFlags()

    return <WrappedComponent {...props} flags={flags} />
  }

  WithFeatureFlags.displayName = `withFeatureFlags(${WrappedComponent.displayName ||
    WrappedComponent.name ||
    'Component'})`

  return WithFeatureFlags
}

export default withFeatureFlags
